import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setToast } from "../../../../app/appSlice";
import { useAppSelector } from "../../../../hooks/hooks";
import { IDomaine, useCheckNifiSynchronisationDomaineMutation, useDomainesQuery, useSynchroniseDomaineNifiMutation } from "../../cdsApiSlice";
import StatusNifiNotSynchronise from "../sourceExterne/nifi/StatusNifiNotSynchronise";

interface IDomaineDetail {
  domaine: IDomaine;
}

const DomainDetail = ({ domaine }: IDomaineDetail) => {

  const [synchroniseNifiDomain,statusSynchroNifiDomaine] =  useSynchroniseDomaineNifiMutation()
  const dispatch = useDispatch();
  const [getNifiState, { data: nifiSatate, ...nifiStatus }] = useCheckNifiSynchronisationDomaineMutation()
  const pagination = useAppSelector((state) => state.cds.domainePagination)
  const { data: domains, ...DomainStatus } = useDomainesQuery(pagination);

  useEffect(() => {
    getNifiState({id:domaine.id})
  },[])

  useEffect(() => {
    if (statusSynchroNifiDomaine.isSuccess) {
        getNifiState({id:domaine.id})
        dispatch(
          setToast({
            title: "NiFi",
            content: `Domaine ${domaine.libelle} synchronisée avec Nifi`,
            severity: "success",
            life: 3000,
          })
        );
        DomainStatus.refetch()
      }
  },[statusSynchroNifiDomaine])



  return (
    <>

      
        <StatusNifiNotSynchronise 
        //@ts-ignore
        functionSyncNifi={(data:IDomaine) => {
            // @ts-ignore
            synchroniseNifiDomain({domaine:data,id:data.id}) 
        }} domaine={domaine} status={statusSynchroNifiDomaine} />
   

      <div className="flex mb-3 mt-3">
        <div className="titleList mr-3">Nom</div>
        <div className="contentList">{domaine.libelle}</div>
      </div>
      <div className="flex mb-3">
        <div className="titleList mr-2">Description</div>
        <div className="contentList">{domaine.description}</div>
      </div>
      <div className="flex mb-3">
        <div className="titleList mr-2">Zone</div>
        <div className="contentList">{domaine.zone}</div>
      </div>
      <div className="flex mb-3">
        <div className="titleList mr-2">Nombre de sources</div>
        <div className="contentList">{domaine.sourcesCount}</div>
      </div>
    </>
  );
};

export default DomainDetail;
